<ng-container [ngSwitch]="getComponentRenderState()">
  <ng-container *ngSwitchCase="'content'">
    <div
      *ngIf="!!redeemCashMembership; else linkYourAccount"
      class="linked-account-container">
      <div
        *ngIf="isRedeemCashToCardType; else redeemCashToAccountType"
        class="linked-account-information">
        <span class="sr-only">{{
          'accessibility.redeem_cash_v2.checkout.selected_account_card_type'
            | translate
              : {
                  loyaltyProgram: groupName,
                  digits: redeemCashMembership.number.substr(-4)
                }
        }}</span>
        <span class="linked-account-label" aria-hidden="true">
          {{
            'redeem_cash_v2.checkout.linked_card_account'
              | translate
                : {
                    loyaltyProgram: groupName
                  }
          }}
        </span>
        <span class="linked-account-number" aria-hidden="true">{{
          displayedAccountNumber()
        }}</span>
      </div>
      <ng-template #redeemCashToAccountType>
        <div class="linked-account-information">
          <span class="sr-only">{{
            'accessibility.redeem_cash_v2.checkout.selected_account_cash_type'
              | translate: { digits: displayedAccountNumber() }
          }}</span>
          <span class="linked-account-label" aria-hidden="true">
            {{ 'redeem_cash_v2.checkout.linked_account' | translate }}
          </span>
          <span class="linked-account-number" aria-hidden="true">{{
            displayedAccountNumber()
          }}</span>
        </div>
      </ng-template>
      <div class="linked-account-action">
        <button
          type="button"
          class="change-linked-account-button"
          (click)="openLinkAccountDialog()"
          [attr.aria-label]="
            'accessibility.redeem_cash_v2.checkout.change' | translate
          ">
          <span class="change-linked-account-text">
            {{ 'redeem_cash_v2.checkout.change' | translate }}
          </span>
        </button>
      </div>
    </div>

    <ng-template #linkYourAccount>
      <rd-shared-button
        class="link-your-account"
        [buttonClass]="'link-your-account'"
        [buttonContent]="buttonContent"
        [buttonTheme]="'primary'"
        (clickFn)="openLinkAccountDialog()">
        <ng-template #buttonContent>
          <div class="link-your-account-text">
            {{ 'redeem_cash_v2.checkout.link_your_account' | translate }}
            <rd-shared-icon
              *ngIf="iconName"
              class="icon-arrow-right"
              [iconSymbol]="iconName"
              [iconTheme]="'white'"></rd-shared-icon>
          </div>
        </ng-template>
      </rd-shared-button>
    </ng-template>
  </ng-container>

  <ng-container *ngSwitchCase="'loading'">
    <div class="link-your-account button-height loading"></div>
  </ng-container>
</ng-container>
